export default "__VITE_ASSET__BlWN313O__"